import { creatorbase } from '@round/api';
import { Image } from '@round/ui-kit';
import OverflowCircleBadgeContainer from 'Modules/Plans/components/OverflowCircleBadgeContainer/OverflowCircleBadgeContainer';
import PartnerClientAvatar from 'Modules/Plans/Partnerships/components/PartnerClientAvatar/PartnerClientAvatar';
import styles from './LinkedAgenciesCard.module.css';

type Props = {
    name: string | undefined;
    logo: string | null | undefined;
    agencies: creatorbase.Partnership[];
    areAgenciesLoading: boolean;
};

const LinkedAgenciesCard = ({ name, logo, agencies, areAgenciesLoading }: Props) => (
    <div className={styles.card}>
        <Image className={styles.logo} src={logo ?? ''} alt={name} />
        <div className={styles.copy}>
            <p className={styles.title}>{name ?? '-'}</p>
            <div className={styles.agenciesRow}>
                <span className={styles.agenciesLabel}>With</span>
                <OverflowCircleBadgeContainer
                    className={styles.agencies}
                    overflowingCountBadgeClassName={styles.overflowCountBadge}
                >
                    {areAgenciesLoading ? (
                        <PartnerClientAvatar className={styles.agencyAvatar} name="" isLoading />
                    ) : (
                        agencies.map((agency) => (
                            <PartnerClientAvatar
                                key={agency.id}
                                className={styles.agencyAvatar}
                                name={agency.agency_name}
                                logo={agency.agency_logo}
                            />
                        ))
                    )}
                </OverflowCircleBadgeContainer>
            </div>
        </div>
    </div>
);

export default LinkedAgenciesCard;
